export const BEANIE = {
    contractVersion: "1",
    componentId: "pY9LVQhdBsk1oTeumyWxui",
    emptyGuid: "00000000-0000-0000-0000-000000000000",
    envProd: 'prod',
    envTest: 'test',
    outboundConnectionEntityType: "outboundConnection",
    outboundConnectionSettingsEntityType: "outboundSettings",
    contractIds: {
        connectionAbandoned: "4becdcdb-9899-4519-939b-f3a67a97ac55",
        connectionCompleted: "b94f0b90-ba22-4fed-a995-d5426070c7a3",
        connectionCreated: "177f4a44-40c2-45b0-a775-cf951c774489",
        connectionDisconnected: "82c0be57-b2c0-46fd-bd83-437f90fbe315",
        connectionStarted: "79ae728d-3777-4eb7-acb9-bc81845a2aa0",
        settingsStepUpdated: "9154ae5b-ee95-46e4-b6b1-3167820edbf1",
    }
}
